import { createTableSettingsStore } from "#lib/table-settings.ts"

export const fleetTableDefaults = {
  columnVisibility: { category: false, source: false },
  sorting: [{ id: "tail", desc: false }],
}

export const useFleetTableSettings = createTableSettingsStore(
  "fleet-table-settings",
  fleetTableDefaults,
)
